import {deepCopy} from "@/auxillary";
import {translate} from "@/auxillary/translation";

export interface IReadonlyFieldData {
    id: string;
    referenceType: string;
    referenceId: string;
    parentFieldId?: string | undefined;
    identifier: string;
    displayKey?: string | undefined;
    displayName?: string | undefined;
    values?: any | undefined;
    definitionType?: string | undefined;
    definition?: any | undefined;
    order?: number;
    tags?: any | undefined;
}

export default class ReadonlyDataField {
    private readonly _definition: any;
    private readonly _fieldData: Readonly<IReadonlyFieldData> | undefined;

    private _childFields: ReadonlyDataField[] = new Array<ReadonlyDataField>();

    private readonly _values: any = {};
    private readonly _tags: any = {};

    private readonly _isDeleted: boolean;
    private readonly _order: number = 0;
    private readonly _isVisible: boolean = true;
    private readonly _displayName?: string;

    // TODO: dont use event report field
    constructor(fieldData: IReadonlyFieldData) {
        this._fieldData = fieldData;

        this._definition = fieldData.definition;
        this._values = deepCopy(fieldData.values);
        this._tags = deepCopy(fieldData.tags);
        this._order = fieldData.order ?? 0;

        this._isVisible = true;
        this._isDeleted = false;
    }

    public get order() {
        return this._order;
    }

    public get id() {
        return this._fieldData?.id;
    }

    public get parentId() {
        return this._fieldData?.parentFieldId;
    }

    public get isDeleted() {
        return this._isDeleted;
    }

    public get isVisible() {
        if (this._isDeleted || this._definition.isDeleted)
            return false;

        return true;
    }

    public get values() {
        return this._values;
    }

    public get currentValues() {
        return this._values;
    }

    public get hasValues() {
        return Object.keys(this._values).length > 0

    }

    public get tags() {
        return this._tags;
    }

    public get childFields() {
        return this._childFields.filter(c => !c.isDeleted && !c.definition.isDeleted);
    }

    public get displayKey() {
        return this._fieldData?.displayKey ?? "";
    }

    public get displayName() {
        if (this._displayName === undefined) {
            return translate(this.displayKey);
        }

        return this._fieldData?.displayName ?? "";
    }

    public get definitionType() {
        return this._fieldData?.definitionType ?? "";
    }

    public get definition() {
        return this._fieldData?.definition ?? {};
    }

    public get referenceId() {
        return this._fieldData?.referenceId;
    }

    public get referenceType() {
        return this._fieldData?.referenceType;
    }

    public get identifier() {
        return this._fieldData?.identifier ?? "";
    }

    public addChild(child: ReadonlyDataField) {
        if (this.childFields.some(childField => childField.id == child.id)) return;

        this._childFields.push(child);
        this._childFields.sort((a, b) => (a.order > b.order) ? 1 : -1)
    }
}
